<script setup lang="ts">
/** DR (Appoint Withdraw Director) — 회사 단위 1부. 선임/사임 목록은 각 인물(Form45/Resignation)에서 도출. 서명 = 현직 이사([[Signers]]). */
import { inject, computed } from 'vue';
import CddVarField from '@/features/startTask/my_preset/sg/aura/agm/cdd/CddVarField.vue';
import AgmSigners from '@/features/startTask/my_preset/sg/aura/agm/cdd/AgmSigners.vue';
import '@/features/startTask/my_preset/sg/aura/agm/docs/agmDoc.css';

interface Row { name: string; nric: string; label: string }
const people = inject<any>('awdPeople', null);
const newList = computed<Row[]>(() => (people?.value?.news as Row[]) || []);
const resignList = computed<Row[]>(() => (people?.value?.resigns as Row[]) || []);
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head" style="text-align:center">
      <div class="doc-company"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div>(Company Registration No.: <CddVarField field-key="company_registration_no" label="UEN" />)</div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>(the “Company”)</div>
    </div>

    <p class="sec-title" style="text-align:center;margin-top:12px">DIRECTORS’ RESOLUTION(S) IN WRITING PASSED PURSUANT TO THE COMPANY’S CONSTITUTION</p>

    <p class="sec-title">1. RESIGNATION OF DIRECTOR(S)</p>
    <p class="doc-p">RESOLVED THAT the resignation of the following person(s) as Director(s) of the Company be hereby noted with regret:</p>
    <div v-if="resignList.length" class="list">
      <div v-for="(d, i) in resignList" :key="'r' + i" class="list-row">{{ d.name }} ({{ d.label }}: {{ d.nric }})</div>
    </div>
    <div v-else class="list-empty">(add directors in “Directors to Withdraw” stage)</div>

    <p class="sec-title">2. APPOINTMENT OF DIRECTOR(S)</p>
    <p class="doc-p">RESOLVED THAT, subject to each having signed Form 45, the following person(s) be and are hereby appointed as Director(s) of the Company with effect from the date of their respective consent to act:</p>
    <div v-if="newList.length" class="list">
      <div v-for="(d, i) in newList" :key="'n' + i" class="list-row">{{ d.name }} ({{ d.label }}: {{ d.nric }})</div>
    </div>
    <div v-else class="list-empty">(add directors in “Directors to Appoint” stage)</div>

    <p class="sec-title">3. LODGEMENT OF NOTICE(S) TO ACRA</p>
    <p class="doc-p">RESOLVED THAT <CddVarField field-key="secretary_firm_name" label="Secretary firm (lodger)" /> be hereby authorised to lodge the requisite notice(s) on the appointment and resignation of Director(s) with ACRA.</p>

    <p class="sec-title">4. DECLARATIONS OF DIRECTOR’S INTEREST(S) IN CONTRACT(S)</p>
    <p class="doc-p">RESOLVED THAT the declarations of interest(s) pursuant to Section 156 of the Companies Act 1967 be recorded.</p>

    <p class="doc-p" style="margin-top:12px">Date: <CddVarField field-key="resolution_date" label="Resolution date" /></p>
    <p class="doc-p"><b>BOARD OF DIRECTORS</b></p>
    <AgmSigners var-key="dr_Signers" board-label="Directors" />
  </div>
</template>

<style scoped>
.doc-company { font-weight: 800; font-size: 13.5px; }
.list { margin: 4px 0 4px 8px; }
.list-row { padding: 2px 0; font-weight: 600; color: #10305c; }
.list-empty { margin: 4px 0 4px 8px; font-size: 11px; color: #b98900; font-style: italic; }
</style>
